import { Page } from '@/core/architecture'

import { LanguageSettingTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * LanguageSetting Page
 * Implemented as a practical sample.
 */
export const LanguageSetting: Page = () => {
  const { state, actions } = useViewModel()

  return <LanguageSettingTemplate state={state} {...actions} />
}
